import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
    GridCol,
    Variant,
    Article,
    Typography,
    Police,
    AlertVariant,
    Alert,
    ContainerMui,
    RadioGroup,
    Radio
} from '../../../../styles';

import { Langues } from '../../../../utils';
import { ParcoursEmprunteur } from '../../../../hooks';
import { Box, useMediaQuery } from '@material-ui/core';
import { IConventionState } from '../../InformationsSignature.utils';

interface ILangueInfoSignature {
    convention: IConventionState;
    parcoursEmprunteur: string;
    loi14Actif: boolean;
    onLangueChange: (lang: string) => void;
}

export const LangueInfoSignature: React.FC<ILangueInfoSignature> = ({
    convention,
    parcoursEmprunteur,
    loi14Actif,
    onLangueChange
}) => {
    const [t] = useTranslation('InformationsSignature');
    const isMobile = useMediaQuery('(max-width:640px)');
    const [langueSelectionne, setLangueSelectionne] = useState(
        convention?.langue
    );
    const isENAndLoi14 =
        convention?.langue === Langues.EN.toString() && loi14Actif === true;

    // Langue
    const renderLangOption = (labelKey: string, lang: Langues) => {
        return (
            <Radio
                dataTestId={
                    'radio_button_' +
                    (lang === Langues.FR ? 'francais' : 'anglais')
                }
                label={t(labelKey)}
                value={lang}
            />
        );
    };

    // Langue
    const renderLangAlert = () => {
        if (isENAndLoi14) {
            return (
                <Box mb="0.5rem">
                    <Alert
                        isFullWidth
                        variant={AlertVariant.information}
                        dataTestId="bloc_texte_loi14"
                        className="dsd-mb-0"
                        dynamic
                    >
                        <h4 slot="title">{t('loi14TitreHorsEcran')}</h4>
                        <Typography variant={Variant.p} article={Article.a3}>
                            {t('loi14AvisPart1')}
                        </Typography>
                        <Typography variant={Variant.p} article={Article.a3}>
                            {t('loi14AvisPart2')}
                        </Typography>
                    </Alert>
                </Box>
            );
        }
    };

    return (
        <ContainerMui
            padding={
                isMobile
                    ? '0.33rem 1rem 0.33rem 1rem'
                    : '0.5rem 1.5rem 0 1.5rem'
            }
            spacerDistance={6}
            minWidth="100%"
            minHeight="fit-content"
        >
            <GridCol col="12">
                <Typography variant={Variant.h3} police={Police.bold}>
                    {t('titreLangue')}
                </Typography>
                {parcoursEmprunteur === ParcoursEmprunteur.COEMPRUNTEUR_GUY && (
                    <Typography variant={Variant.p} article={Article.a3}>
                        {t('descriptionLangueGuy')}
                    </Typography>
                )}
                <Typography variant={Variant.p} article={Article.a3}>
                    {t(
                        parcoursEmprunteur ===
                            ParcoursEmprunteur.COEMPRUNTEUR_MARTINE
                            ? 'descriptionLangueMartine'
                            : 'descriptionLangue'
                    )}
                </Typography>
                {parcoursEmprunteur ===
                ParcoursEmprunteur.COEMPRUNTEUR_MARTINE ? (
                    <Typography
                        variant={Variant.p}
                        article={Article.a3}
                        police={Police.bold}
                        marginBottom="0.5rem"
                        hideMarginBottom={isENAndLoi14}
                    >
                        {t(convention?.langue)}
                    </Typography>
                ) : (
                    <RadioGroup
                        name={'infos_signature_radiogroup_langue'}
                        value={langueSelectionne}
                        onChange={(newLang) => {
                            setLangueSelectionne(newLang);
                            onLangueChange(newLang);
                        }}
                        column
                    >
                        {renderLangOption('optionLangueFrancais', Langues.FR)}
                        {renderLangOption('optionLangueAnglais', Langues.EN)}
                    </RadioGroup>
                )}
                {renderLangAlert()}
            </GridCol>
        </ContainerMui>
    );
};
